// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7ac3901c","436":"b59bc2b9","455":"57fa4cc0","538":"cf8fcd6c","565":"a91d8303","945":"783f694b","978":"f9147364"}[chunkId] + ".chunk.js";
};